import type { AuthRole } from '../types';

const ROLE_LABELS: Record<AuthRole, string> = {
	platform_admin: 'Platform admin',
	admin: 'Admin',
	member: 'Member',
};

/**
 * Whether the role may manage its own tenant (content, customers, audit and
 * users). UI gating only: the backend enforces authorization.
 */
export function canManageTenant(role: AuthRole | null | undefined): boolean {
	return role === 'admin' || role === 'platform_admin';
}

/** Platform admins can additionally manage users of any tenant. */
export function isPlatformAdmin(role: AuthRole | null | undefined): boolean {
	return role === 'platform_admin';
}

export function isAuthRole(value: unknown): value is AuthRole {
	return typeof value === 'string' && Object.hasOwn(ROLE_LABELS, value);
}

/** Display label for a role; unknown values are shown as-is. */
export function getRoleLabel(role: string): string {
	return isAuthRole(role) ? ROLE_LABELS[role] : role;
}
